(function() {
  'use strict';

  let splideInstance = null;
  const ARROW_SVG = '<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.97228 0.527832L4.75005 4.75005L0.527832 0.527832" stroke="#A6A39E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function syncAccordionRightPanelForItem(itemEl) {
    if (!itemEl) return;
    const rightCol = itemEl.querySelector('[id^="research-content-container"]');
    if (!rightCol || rightCol.querySelector('.clinical-accordion-detail.active')) return;
    const firstOpen = itemEl.querySelector('.clinical-accordion details[open] summary[data-id]');
    const detailId = firstOpen?.getAttribute('data-id');
    if (!detailId) return;
    const desktop = document.getElementById(detailId);
    if (desktop) desktop.classList.add('active');
    const mobileId = detailId.replace('accordion-detail-', 'mobile-accordion-detail-');
    const mobile = document.getElementById(mobileId);
    if (mobile) mobile.classList.add('active');
  }

  function updateActiveContent(slideIndex, sliderId) {
    const researchButtons = document.querySelectorAll('.research-product-item');
    const researchItems = document.querySelectorAll('.clinical-research-results-item');
    const slider = document.querySelector(sliderId);

    if (!slider) return;

    const slides = slider.querySelectorAll('.splide__slide');
    if (slideIndex < 0 || slideIndex >= slides.length) return;

    const activeSlide = slides[slideIndex];
    const activeButton = activeSlide.querySelector('.research-product-item');
    
    if (!activeButton) return;

    const itemId = activeButton.getAttribute('data-id');

    researchButtons.forEach(btn => btn.classList.remove('active'));
    researchItems.forEach(item => item.classList.remove('active'));

    activeButton.classList.add('active');

    const targetItem = document.getElementById(itemId);
    if (targetItem) {
      targetItem.classList.add('active');
      syncAccordionRightPanelForItem(targetItem);
    }
  }

  function initSplide(sliderId, selectedItem) {
    const slider = document.querySelector(sliderId);
    const slides = slider?.querySelectorAll('.splide__slide');

    if (slider && slides && slides.length > 0 && typeof Splide !== 'undefined') {
      splideInstance = new Splide(sliderId, {
        // type: 'slide',
        perPage: 'auto',
        perMove: 1,
        focus: 'center',
        gap: '1rem',
        fixedWidth: '284px',
        pagination: false,
        arrows: true
      });

      splideInstance.on('moved', function(newIndex) {
        updateActiveContent(newIndex, sliderId);
      });

      splideInstance.mount();
      const parsedSelectedItem = parseInt(selectedItem) || 0;
      if (parsedSelectedItem >= 1) {
        splideInstance.go(parsedSelectedItem - 1);
      } else {
        setTimeout(() => {
          const currentIndex = splideInstance.index;
          updateActiveContent(currentIndex, sliderId);
        }, 100);
      }
    }
  }

  function activateResearchItem(itemId, sliderId) {
    const researchButtons = document.querySelectorAll('.research-product-item');
    const researchItems = document.querySelectorAll('.clinical-research-results-item');
    const slider = document.querySelector(sliderId);
    const mobileDropdown = document.querySelector('.mobile-dropdown-wrapper');
    const dropdownToggle = mobileDropdown?.querySelector('.custom-dropdown-toggle');
    const dropdownOptions = mobileDropdown?.querySelector('.custom-dropdown-options');

    researchButtons.forEach(btn => btn.classList.remove('active'));
    researchItems.forEach(item => item.classList.remove('active'));

    const clickedButton = document.querySelector(`.research-product-item[data-id="${itemId}"]`);
    if (clickedButton) {
      clickedButton.classList.add('active');
    }

    const targetItem = document.getElementById(itemId);
    if (targetItem) {
      targetItem.classList.add('active');
      syncAccordionRightPanelForItem(targetItem);
    }

    if (dropdownToggle) {
      const dropdownOptionButton = dropdownOptions?.querySelector(`.dropdown-option[data-id="${itemId}"]`);
      if (dropdownOptionButton) {
        const buttonContent = dropdownOptionButton.innerHTML;
        dropdownToggle.innerHTML = '<div class="selected-option">' + buttonContent + '</div>' + ARROW_SVG;
        dropdownToggle.setAttribute('data-id', itemId);
        dropdownToggle.classList.add('active');
      }
    }

    if (dropdownOptions) {
      dropdownOptions.classList.remove('open');
    }

    if (splideInstance && slider) {
      const slides = slider.querySelectorAll('.splide__slide');
      const slideIndex = Array.from(slides).findIndex(slide => {
        return slide.querySelector('.research-product-item[data-id="' + itemId + '"]');
      });
      
      if (slideIndex !== -1) {
        splideInstance.go(slideIndex);
      }
    }
  }

  function initResearchProductButtons(sliderId) {
    const researchButtons = document.querySelectorAll('.research-product-item:not(.custom-dropdown-toggle)');
    const mobileDropdown = document.querySelector('.mobile-dropdown-wrapper');
    const dropdownToggle = mobileDropdown?.querySelector('.custom-dropdown-toggle');
    const dropdownOptions = mobileDropdown?.querySelector('.custom-dropdown-options');
    const dropdownOptionButtons = mobileDropdown?.querySelectorAll('.dropdown-option');

    researchButtons.forEach((button) => {
      button.addEventListener('click', function() {
        const itemId = this.getAttribute('data-id');
        if (itemId) {
          activateResearchItem(itemId, sliderId);
        }
      });
    });

    if (dropdownToggle) {
      dropdownToggle.addEventListener('click', function(e) {
        e.stopPropagation();
        if (dropdownOptions) {
          dropdownOptions.classList.toggle('open');
        }
      });
    }

    if (dropdownOptionButtons) {
      dropdownOptionButtons.forEach(button => {
        button.addEventListener('click', function() {
          const itemId = this.getAttribute('data-id');
          if (itemId) {
            activateResearchItem(itemId, sliderId);
          }
        });
      });
    }

    document.addEventListener('click', function(e) {
      if (mobileDropdown && dropdownOptions && !mobileDropdown.contains(e.target)) {
        dropdownOptions.classList.remove('open');
      }
    });
  }

  function getVisibleCardCount() {
    return 4;
  }

  function updateCardVisibility() {
    const containers = document.querySelectorAll('.more-research-container');
    const visibleCount = getVisibleCardCount();
    
    containers.forEach(container => {
      const cards = container.querySelectorAll('.more-research-card');
      const itemId = container.getAttribute('data-container-id');
      const loadMoreButton = document.getElementById(`load-more-${itemId}`);
      const loadMoreCta = loadMoreButton?.closest('.more-research-cta');
      
      let hasHiddenCards = false;
      
      cards.forEach((card, index) => {
        if (index < visibleCount) {
          card.classList.remove('hidden-card');
        } else {
          card.classList.add('hidden-card');
          hasHiddenCards = true;
        }
      });
      
      if (loadMoreCta) {
        if (hasHiddenCards) {
          loadMoreCta.style.display = 'flex';
        } else {
          loadMoreCta.style.display = 'none';
        }
      }
    });
  }

  function initLoadMoreButtons() {
    const loadMoreButtons = document.querySelectorAll('[id^="load-more-"]');
    
    loadMoreButtons.forEach(button => {
      button.addEventListener('click', function() {
        const itemId = this.getAttribute('data-item-id');
        const container = document.querySelector(`.more-research-container[data-container-id="${itemId}"]`);
        
        if (container) {
          const hiddenCards = container.querySelectorAll('.hidden-card');
          hiddenCards.forEach(card => {
            card.style.display = 'flex';
            card.classList.remove('hidden-card');
          });
          
          this.closest('.more-research-cta').style.display = 'none';
        }
      });
    });
  }

  function initAccordion(accordionContainer) {
    if (!accordionContainer) return;

    function updateToggle(details, toggle) {
      const isOpen = details.hasAttribute('open');
      toggle.textContent = isOpen ? '−' : '+';
    }

    function isMobile() {
      return window.innerWidth <= 1120;
    }

    function activateDetail(detailId) {
      if (!detailId) return;

      const targetDetail = document.getElementById(detailId);
      if (targetDetail) {
        targetDetail.classList.add('active');
      }

      const mobileDetailId = detailId.replace('accordion-detail-', 'mobile-accordion-detail-');
      const targetMobileDetail = document.getElementById(mobileDetailId);
      if (targetMobileDetail) {
        targetMobileDetail.classList.add('active');
      }
    }

    const accordionItems = accordionContainer.querySelectorAll('.clinical-accordion__item');
    const resultsItem = accordionContainer.closest('.clinical-research-results-item');
    const detailActiveScope = resultsItem || accordionContainer.closest('.clinical-research-results-content') || document;
    const researchContentContainer = accordionContainer.closest('.clinical-research-results-item')?.querySelector('#research-content-container, [id^="research-content-container-"]');

    accordionItems.forEach(item => {
      const details = item.querySelector('details');
      const summary = item.querySelector('summary');
      const toggle = item.querySelector('.clinical-accordion__toggle');
      const content = item.querySelector('.clinical-accordion__content');

      if (!details || !summary || !toggle || !content) return;

      updateToggle(details, toggle);

      summary.addEventListener('click', function(e) {
        e.preventDefault();

        const isOpen = details.hasAttribute('open');
        const detailId = summary.getAttribute('data-id');

        if (isOpen && !isMobile()) {
          return;
        }

        detailActiveScope.querySelectorAll('.clinical-accordion-detail').forEach((div) => {
          div.classList.remove('active');
        });

        if (!isOpen) {
          accordionItems.forEach(otherItem => {
            if (otherItem !== item) {
              const otherDetails = otherItem.querySelector('details');
              const otherToggle = otherItem.querySelector('.clinical-accordion__toggle');
              if (otherDetails && otherDetails.hasAttribute('open')) {
                otherDetails.removeAttribute('open');
                if (otherToggle) {
                  updateToggle(otherDetails, otherToggle);
                }
              }
            }
          });
        }

        if (isOpen) {
          details.removeAttribute('open');
        } else {
          details.setAttribute('open', '');
          activateDetail(detailId);

          if (isMobile()) {
            setTimeout(() => {
              const detailsRect = details.getBoundingClientRect();
              const scrollPosition = window.pageYOffset + detailsRect.top - 50;
              window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
            }, 100);
          } else {
            if (researchContentContainer) {
              researchContentContainer.scrollIntoView({ behavior: 'smooth' });
            }
          }
        }

        updateToggle(details, toggle);
      });
    });

    const firstOpenDetails = accordionContainer.querySelector('details[open]');
    if (firstOpenDetails) {
      const firstSummary = firstOpenDetails.querySelector('summary');
      if (firstSummary) {
        const firstDetailId = firstSummary.getAttribute('data-id');
        activateDetail(firstDetailId);
      }
    }
  }

  function initAccordions() {
    const accordionContainers = document.querySelectorAll('.clinical-accordion');
    accordionContainers.forEach(container => {
      initAccordion(container);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    const productLevelResearches = document.querySelector('.product-level-researches');
    if (!productLevelResearches) return;

    const sectionId = productLevelResearches.getAttribute('data-section-id') || '';
    const sliderId = `#research-products-slider-${sectionId}`;
    const selectedItem = productLevelResearches.getAttribute('data-selected-item') || '0';

    const dropdownToggle = document.querySelector('.custom-dropdown-toggle');
    if (dropdownToggle) {
      const initialItemId = dropdownToggle.getAttribute('data-id');
      if (initialItemId) {
        activateResearchItem(initialItemId, sliderId);
      }
    }

    initSplide(sliderId, selectedItem);
    initResearchProductButtons(sliderId);
    initLoadMoreButtons();
    initAccordions();
    
    updateCardVisibility();
    
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        updateCardVisibility();
      }, 250);
    });
  });
})();

